import React from 'react';

const LoadingState = () => {
  return (
    <div className="text-center py-12">
      <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      <p className="mt-4 text-gray-600">Loading helpers...</p>
    </div>
  );
};

export default LoadingState;